export default "__VITE_ASSET__08cc71ba__"